"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
require('dayjs/locale/en-gb');
dayjs_1.default.extend(require('dayjs/plugin/localeData'));
dayjs_1.default.extend(require('dayjs/plugin/advancedFormat'));
dayjs_1.default.extend(require('dayjs/plugin/customParseFormat'));
function formatDay(day, locale) {
    return dayjs_1.default(day)
        .locale(locale || 'en-gb')
        .format('ddd ll');
}
exports.formatDay = formatDay;
function formatMonthTitle(month, locale) {
    return dayjs_1.default(month)
        .locale(locale || 'en-gb')
        .format('MMMM YYYY');
}
exports.formatMonthTitle = formatMonthTitle;
function formatWeekdayShort(weekday, locale) {
    return dayjs_1.default().locale(locale || 'en-gb').localeData().weekdaysMin()[weekday];
}
exports.formatWeekdayShort = formatWeekdayShort;
function formatWeekdayLong(weekday, locale) {
    return dayjs_1.default().locale(locale || 'en-gb').localeData().weekdays()[weekday];
}
exports.formatWeekdayLong = formatWeekdayLong;
function getFirstDayOfWeek(locale) {
    return locale === 'none' ? 0 : 1;
}
exports.getFirstDayOfWeek = getFirstDayOfWeek;
function getMonths(locale) {
    var months = [];
    var i = 0;
    while (i < 12) {
        months.push(dayjs_1.default()
            .locale(locale || 'en-gb')
            .month(i)
            .format('MMMM'));
        i += 1;
    }
    return months;
}
exports.getMonths = getMonths;
function formatDate(date, format, locale) {
    var form = format || 'L';
    return dayjs_1.default(date)
        .locale(locale || 'en-gb')
        .format(Array.isArray(form) ? form[0] : form);
}
exports.formatDate = formatDate;
function parseDate(str, format, locale) {
    var m = dayjs_1.default(str, format, locale || 'en-gb', true);
    if (m.isValid()) {
        return m.toDate();
    }
    return undefined;
}
exports.parseDate = parseDate;
exports.default = {
    formatDay: formatDay,
    formatMonthTitle: formatMonthTitle,
    formatWeekdayShort: formatWeekdayShort,
    formatWeekdayLong: formatWeekdayLong,
    getFirstDayOfWeek: getFirstDayOfWeek,
    getMonths: getMonths,
    formatDate: formatDate,
    parseDate: parseDate,
};
//# sourceMappingURL=dayjsUtils.js.map